'use client';

import React from 'react';
import { useLanguage } from './LanguageContext';

export default function TranslateButton() {
  const { isSpanish, loading, toggle } = useLanguage();

  return (
    <button
      onClick={toggle}
      data-translate-ignore
      disabled={loading}
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-black text-white text-sm font-semibold px-5 py-3 rounded-full shadow-lg hover:bg-gray-800 active:scale-95 transition-all duration-200 whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
      aria-label={isSpanish ? 'Translate to English' : 'Translate to Spanish'}
    >
      {loading ? 'Translating…' : isSpanish ? 'Translate to English' : 'Translate to Spanish'}
    </button>
  );
}
